export enum Role {
    SAdmin = 'SuperAdmin',
    Admin = 'Admin',
    VAdmin = 'Vendor Admin',
    VUser = 'VUser',
    PP = 'Procurement Personal',
    DAdmin ='DAdmin',
    UpAdmin = 'Uptime Admin'
  }